import React, { useState, useEffect } from 'react';
import { getAuditLogs } from '../services/api';
import Modal from './Modal';
import { HiOutlineClock } from 'react-icons/hi';

const ACTION_LABELS = {
  create: 'Creation',
  update: 'Modification',
  delete: 'Suppression',
  update_statut: 'Changement statut',
  update_commentaire: 'Commentaire',
  ai_create: 'Generation IA',
  ai_improve: 'Amelioration IA',
  import: 'Import',
};

const ACTION_CLASSES = {
  create: 'audit-action-create',
  update: 'audit-action-update',
  delete: 'audit-action-delete',
  update_statut: 'audit-action-update',
  update_commentaire: 'audit-action-update',
  ai_create: 'audit-action-ai',
  ai_improve: 'audit-action-ai',
  import: 'audit-action-create',
};

function truncate(str, max = 80) {
  if (!str) return '';
  return str.length > max ? str.substring(0, max) + '...' : str;
}

function formatDate(isoStr) {
  if (!isoStr) return '';
  const d = new Date(isoStr);
  return d.toLocaleDateString('fr-FR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export default function AuditLogModal({ show, onClose, projectId, entityType, entityId, entityLabel }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!show) return;
    setLoading(true);
    setError('');
    const params = {};
    if (entityType) params.entity_type = entityType;
    if (entityId != null) params.entity_id = entityId;
    params.limit = 100;
    getAuditLogs(projectId, params)
      .then((res) => setLogs(res.data))
      .catch(() => setError('Erreur lors du chargement de l\'historique.'))
      .finally(() => setLoading(false));
  }, [show, projectId, entityType, entityId]);

  const footer = (
    <button className="btn btn-secondary btn-sm" onClick={onClose}>Fermer</button>
  );

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={`Historique — ${entityLabel || 'Projet'}`}
      icon={<HiOutlineClock />}
      size="lg"
      footer={footer}
    >
      <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        {loading && <div className="text-center py-4"><div className="spinner-border text-primary"></div></div>}
        {error && <div className="alert alert-danger">{error}</div>}
        {!loading && !error && logs.length === 0 && (
          <p className="text-muted text-center py-3">Aucune modification enregistree.</p>
        )}
        {!loading && logs.length > 0 && (
          <table className="table table-sm table-hover mb-0">
            <thead>
              <tr>
                <th style={{ width: '140px' }}>Date</th>
                <th style={{ width: '110px' }}>Utilisateur</th>
                <th style={{ width: '120px' }}>Action</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => {
                let changes = {};
                try { changes = JSON.parse(log.changes); } catch { /* ignore */ }
                const changedFields = Object.keys(changes);

                return (
                  <tr key={log.id}>
                    <td className="text-nowrap small">{formatDate(log.performed_at)}</td>
                    <td className="small">{log.performed_by_username}</td>
                    <td>
                      <span className={`audit-action-badge ${ACTION_CLASSES[log.action] || 'audit-action-update'}`}>
                        {ACTION_LABELS[log.action] || log.action}
                      </span>
                    </td>
                    <td className="small">
                      {changedFields.length === 0 && log.action === 'delete' && (
                        <span className="text-muted">Element supprime</span>
                      )}
                      {changedFields.length === 0 && log.action === 'create' && (
                        <span className="text-muted">Element cree</span>
                      )}
                      {changedFields.map((field) => {
                        const c = changes[field];
                        if (c && typeof c === 'object' && ('before' in c || 'after' in c)) {
                          return (
                            <div key={field} className="mb-1">
                              <strong>{field}</strong> :{' '}
                              <span className="text-danger">{truncate(String(c.before || ''))}</span>
                              {' → '}
                              <span className="text-success">{truncate(String(c.after || ''))}</span>
                            </div>
                          );
                        }
                        return (
                          <div key={field}>
                            <strong>{field}</strong> : {truncate(String(c || ''))}
                          </div>
                        );
                      })}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </Modal>
  );
}
